import { INotificationService } from './interfaces';
import { notify, translateAndNotifyError, translateAndNotifySuccess } from './service';

export const NotificationAdapter = (): INotificationService => {
  // const { translateAndNotifyError, translateAndNotifySuccess } = NotificationsService();

  return {
    notify: notify(),
    translateAndNotifyError: translateAndNotifyError(),
    translateAndNotifySuccess: translateAndNotifySuccess(),
  };
};
